import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../views/HomePage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/scan",
    name: "scan",
    component: () => import("../views/ScanPage.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutPage.vue"),
  },
  {
    path: "/product-result",
    name: "product-result",
    component: () => import("@/views/ProductResult.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/ErrorPage.vue"),
  },
  {
    path: "/manual-scan",
    name: "manual-scan",
    component: () => import("@/views/ManualScan.vue"),
  },
  {
    path: "/company-form",
    name: "company-form",
    component: () => import("@/views/CompanyForm.vue"),
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("@/views/LoadingPage.vue"),
  },
  {
    path: "/success",
    name: "success",
    component: () => import("@/views/SubmissionSuccess.vue"), // Success Page
  },
  {
    path: "/404",
    name: "fail",
    component: () => import("@/views/SubmissionFail.vue"), // Failure Page
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
